'use client';
import Image from 'next/image';
import Link from 'next/link';

const Footer = () => {
  return (
    <footer className="w-full bg-footer-background">
      <div className="w-full max-w-[1440px] mx-auto py-10 sm:py-14 lg:py-[70px] px-4 sm:px-6 lg:px-14 xl:px-20">
        
        {/* Main Footer Grid - 3 Column Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mb-8 lg:mb-12">
          
          {/* Column 1 - Logo & Social Media */}
          <div className="flex flex-col gap-5 sm:gap-6 justify-start items-start">
            <Image 
              src="/images/img_logo.svg" 
              alt="Purple Cow Logo"
              width={206}
              height={30}
              className="w-[180px] sm:w-[200px] lg:w-[206px] h-auto"
            />
            
            <div className="flex flex-row gap-3 lg:gap-[10px] justify-start items-center">
              <button 
                onClick={() => window.open('https://www.facebook.com/PurpleCowAgency', '_blank', 'noopener,noreferrer')}
                className="w-10 h-10 lg:w-12 lg:h-12 bg-primary-background rounded-full p-2.5 hover:bg-primary-dark transition-colors duration-200"
                aria-label="Facebook"
              >
                <Image 
                  src="/images/img_gg_facebook.svg" 
                  alt="Facebook"
                  width={20}
                  height={20}
                  className="w-full h-full"
                />
              </button>
              
              <button 
                onClick={() => window.open('https://www.linkedin.com/company/purple-cow-agency-opc/?originalSubdomain=ph', '_blank', 'noopener,noreferrer')}
                className="w-10 h-10 lg:w-12 lg:h-12 bg-primary-background rounded-full p-2.5 hover:bg-primary-dark transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Image 
                  src="/images/img_ri_linkedin_fill.svg" 
                  alt="LinkedIn"
                  width={20}
                  height={20}
                  className="w-full h-full"
                />
              </button>
            </div>
          </div>

          {/* Column 2 - Navigation Links */}
          <div className="flex flex-col justify-start items-start">
            <h3 className="text-[18px] sm:text-[20px] lg:text-[22px] font-poppins font-semibold leading-[1.5] text-left text-primary-light mb-4 lg:mb-5">
              Quick Links
            </h3>
            <ul className="flex flex-col justify-start items-start gap-3 lg:gap-4">
              <li>
                <Link 
                  href="/about"
                  className="text-[15px] sm:text-[16px] lg:text-[18px] font-poppins font-normal leading-[1.5] text-left text-text-white hover:text-primary-light transition-colors duration-200"
                >
                  About
                </Link>
              </li>
              <li>
                <Link 
                  href="/how-it-works-process-guide"
                  className="text-[15px] sm:text-[16px] lg:text-[18px] font-poppins font-normal leading-[1.5] text-left text-text-white hover:text-primary-light transition-colors duration-200"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link 
                  href="/pricing-plans-subscription-details"
                  className="text-[15px] sm:text-[16px] lg:text-[18px] font-poppins font-normal leading-[1.5] text-left text-text-white hover:text-primary-light transition-colors duration-200"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link 
                  href="/contact"
                  className="text-[15px] sm:text-[16px] lg:text-[18px] font-poppins font-normal leading-[1.5] text-left text-text-white hover:text-primary-light transition-colors duration-200"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Address */}
          <div className="flex flex-col justify-start items-start">
            <h3 className="text-[18px] sm:text-[20px] lg:text-[22px] font-poppins font-semibold leading-[1.5] text-left text-primary-light mb-4 lg:mb-5">
              Our Location
            </h3>
            <p className="text-[15px] sm:text-[16px] lg:text-[18px] font-poppins font-light leading-[1.6] text-left text-text-white">
              4695 Chabot Dr, Ste 200,<br />
              Pleasanton, CA 94588
            </p>
          </div>
        </div>

        {/* Bottom Bar - Copyright */}
        <div className="border-t border-gray-700 pt-6 lg:pt-8">
          <p className="text-[13px] sm:text-[14px] lg:text-[15px] font-poppins font-light text-center text-text-white opacity-80">
            © {new Date()?.getFullYear()} Purple Cow Agency. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer
